/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Notification } from '../../models/notification';
import { NotificationTitle } from '../../models/notification-title';

export interface UpdateNotificationByTitle$Params {
  title: NotificationTitle;
}

export function updateNotificationByTitle(http: HttpClient, rootUrl: string, params: UpdateNotificationByTitle$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Notification>>> {
  const rb = new RequestBuilder(rootUrl, updateNotificationByTitle.PATH, 'get');
  if (params) {
    rb.path('title', params.title, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Notification>>;
    })
  );
}

updateNotificationByTitle.PATH = '/api/notification/update/{title}';
